import {addPaymentInfoEventTrigger} from './add-payment-info.js';
import {addToCartEventTrigger} from './add-to-cart.js';
import {buyingIntentionEventTrigger} from './buying-intention.js';
import {carouselScrollEventTrigger} from './carousel-scroll.js'; // image-product-detail-v2 Cuando acabe el test, o veamos que pasa, eliminar este evento
import {commentOwnProductEventTrigger} from './comment-own-product.js';
import {commentEventTrigger} from './comment.js';
import {firstTimeListerEventTrigger} from './first-time-lister.js';
import {homeDeliveryEventTrigger} from './home-delivery.js';
import {initiateCheckoutEventTrigger} from './initiate-checkout.js';
import {likeEventTrigger} from './like.js';
import {offerEventTrigger} from './offer.js';
import {pointDeliveryEventTrigger} from './point-delivery.js';
import {productViewEventTrigger} from './product-view.js';
import {publishEventTrigger} from './publish.js';
import {registrationEventTrigger} from './registration.js';
import {searchEventTrigger} from './search.js';
import {sellingIntentionEventTrigger} from './selling-intention.js';
import {purchaseEventTrigger} from './purchase.js';

buyingIntentionEventTrigger();
sellingIntentionEventTrigger();
addPaymentInfoEventTrigger();
addToCartEventTrigger();
carouselScrollEventTrigger(); // image-product-detail-v2 Cuando acabe el test, o veamos que pasa, eliminar este evento
commentEventTrigger();
commentOwnProductEventTrigger();
firstTimeListerEventTrigger()
homeDeliveryEventTrigger();
initiateCheckoutEventTrigger();
likeEventTrigger();
offerEventTrigger();
pointDeliveryEventTrigger();
productViewEventTrigger();
publishEventTrigger();
registrationEventTrigger();
searchEventTrigger();
purchaseEventTrigger();